module.exports = function setupPlugins(appInstance) {
    appInstance.plugins = new Set();

    appInstance.registerPlugin = function (plugin, options = {}) {
        if (this.plugins.has(plugin)) return this;
        this.plugins.add(plugin);

        const pluginMeta = Symbol.for('plugin-meta');
        let pluginContext = this;

        const isGlobal = plugin[pluginMeta] && plugin[pluginMeta].global === true;
        if (!isGlobal) {
            pluginContext = Object.create(this);
        }

        try {
            if (typeof plugin === 'function') {
                plugin(pluginContext, options);
            } else if (typeof plugin === 'object' && typeof plugin.register === 'function') {
                plugin.register(pluginContext, options);
            } else {
                throw new Error('Invalid plugin format. Must be a function or an object with a register method.');
            }
        } catch (err) {
            console.error(`[fullstx] Error registering plugin:`, err);
        }
        return this;
    };
};
